module.exports = __webpack_public_path__ + "static/media/back.3c2f87fe.png";